<template>
  <div class="iframe-wrapper">
    <div class="downloadLink">
      <a :href="doc.url" target="_blank">Download</a>
    </div>
    <embed :src="doc.url" type="application/pdf" width="100%" height="100%">
  </div>
</template>
<script>
export default {
  props: ['doc'],
}
</script>
<style scoped>
.iframe-wrapper {
  height: 100%;
  width: 100%;
  border: 0;
}

iframe {
  border: 0;
}

div.downloadLink {
  @media only screen and (min-width: 769px) {
    display: none;
  }

  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

a {
  padding: 1rem;
  color: #e35e32;

}
</style>
